import { useEffect, useRef, useState } from 'react';
import { getTrackerPrefs, startKeepAlive, stopKeepAlive, checkPositionsAndSpeak, CHECK_INTERVAL_MS } from '../../services/positionTrackerService';

// Headless — no UI of its own. The on/off toggle lives in Settings →
// Alerts; this component just watches the persisted preference and runs
// the actual 5-minute interval wherever it's mounted (App.js, so it runs
// regardless of which screen Sir is on).
const IS_ELECTRON = !!(window.electronAPI && window.electronAPI.isElectron);

export default function PositionTracker() {
  const [enabled, setEnabled] = useState(() => getTrackerPrefs().enabled);
  const intervalRef = useRef(null);

  // Preferences can change from the Settings screen, which isn't a parent
  // of this component — poll the flag cheaply rather than plumbing a
  // dedicated event bus just for one boolean.
  useEffect(() => {
    const t = setInterval(() => setEnabled(getTrackerPrefs().enabled), 2000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (IS_ELECTRON || !enabled) {
      clearInterval(intervalRef.current);
      return;
    }
    // Best-effort — may get blocked by autoplay policy if there was no
    // fresh user gesture (e.g. preference was already on from a previous
    // session); the toggle's own click handler also calls this directly,
    // which does have a gesture. Either way the check/speak loop below
    // still runs regardless of whether this succeeds.
    startKeepAlive();
    checkPositionsAndSpeak(); // first check immediately, don't wait 5 min
    intervalRef.current = setInterval(checkPositionsAndSpeak, CHECK_INTERVAL_MS);
    return () => clearInterval(intervalRef.current);
  }, [enabled]);

  useEffect(() => () => stopKeepAlive(), []); // stop the audio loop if this ever unmounts

  return null;
}
